export default __webpack_public_path__ + "static/media/h100-1.a21e3ba5.png";